import { BitkitIconComponent, BitkitTooltip, IconInfoCircle } from '@bitrise/bitkit-v2';
import { ComponentProps } from 'react';

type IconTooltipProps = {
  text: string;
  icon?: BitkitIconComponent;
} & Omit<ComponentProps<BitkitIconComponent>, 'color' | 'size'>;

export const IconTooltip = ({ text, icon: Icon = IconInfoCircle, ...rest }: IconTooltipProps) => (
  <BitkitTooltip text={text}>
    <Icon {...rest} color="icon/tertiary" size="16" />
  </BitkitTooltip>
);
